import React from 'react'

const OurTeam = () => {
  return (
    <div>Under Construction</div>
  )
}

export default OurTeam